export default "__VITE_ASSET__addfa99b__"